import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
  },
  bar: {
    width: 20,
    height: 8,
    backgroundColor: '#A82A42',
    flexShrink: 0,
  },
  word: {
    fontFamily: '"Silkscreen", monospace',
    fontWeight: 700,
    fontSize: 26,
    lineHeight: 1,
    letterSpacing: '0.02em',
    color: '#13849E',
    userSelect: 'none',
  },
});

export const LogoFull = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <span className={classes.bar} aria-hidden="true" />
      <span className={classes.word}>fbeta</span>
    </div>
  );
};
